var _excluded = ["spacing", "className", "children", "iconColor", "iconSize", "icon", "isChecked", "onChange"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import { tqc, forwardRef, omitThemingProps, useMultiStyleConfig } from '../../system';
import { callAll, cx, __DEV__, dataAttr } from '../../utils';
import * as React from 'react';
import { useCheckboxGroupContext } from './checkbox-group';
import { CheckboxIcon } from './checkbox-icon';
import { useCheckbox } from './use-checkbox';
var StyledControl = tqc('div', {
  baseStyle: {
    display: 'inline-flex',
    alignItems: 'center',
    background: 'white',
    justifyContent: 'center',
    verticalAlign: 'top',
    userSelect: 'none',
    flexShrink: 0,
    position: 'relative',
    top: '2px'
  }
});
var StyledContainer = tqc('label', {
  baseStyle: {
    cursor: 'pointer',
    display: 'inline-flex',
    alignItems: 'flex-start',
    verticalAlign: 'top',
    position: 'relative',
    _disabled: {
      cursor: 'not-allowed'
    }
  }
});
/**
 * Checkbox
 *
 * React component used in forms when a user needs to select
 * multiple values from several options.
 */
export var Checkbox = forwardRef((props, ref) => {
  var group = useCheckboxGroupContext();
  var mergedProps = _objectSpread(_objectSpread({}, group), props);
  var styles = useMultiStyleConfig('Checkbox', mergedProps);
  var ownProps = omitThemingProps(props);
  var {
      spacing = '0.75rem',
      className,
      children,
      iconColor,
      iconSize,
      icon: Icon = /*#__PURE__*/React.createElement(CheckboxIcon, null),
      isChecked: isCheckedProp,
      onChange: onChangeProp
    } = ownProps,
    rest = _objectWithoutProperties(ownProps, _excluded);
  var isChecked = isCheckedProp;
  if (group !== null && group !== void 0 && group.value && ownProps.value) {
    isChecked = group.value.includes(ownProps.value);
  }
  var onChange = onChangeProp;
  if (group !== null && group !== void 0 && group.onChange && ownProps.value) {
    onChange = callAll(group.onChange, onChangeProp);
  }
  var {
    state,
    getInputProps,
    getCheckboxProps,
    getLabelProps,
    htmlProps
  } = useCheckbox(_objectSpread(_objectSpread({}, rest), {}, {
    isChecked,
    onChange
  }));
  var _className = cx('tqc-checkbox', className);
  var inputProps = getInputProps({}, ref);
  var labelProps = getLabelProps();
  var checkboxProps = getCheckboxProps();
  var iconStyles = _objectSpread({
    opacity: state.isChecked || state.isIndeterminate ? 1 : 0,
    fontSize: iconSize,
    color: iconColor
  }, styles.icon);
  var clonedIcon = /*#__PURE__*/React.cloneElement(Icon, {
    __css: iconStyles,
    isIndeterminate: state.isIndeterminate,
    isChecked: state.isChecked
  });
  return /*#__PURE__*/React.createElement(StyledContainer, _extends({
    __css: styles.container,
    "data-disabled": dataAttr(state.isDisabled),
    className: _className
  }, htmlProps), /*#__PURE__*/React.createElement("input", _extends({
    className: "tqc-checkbox__input"
  }, inputProps)), /*#__PURE__*/React.createElement(StyledControl, _extends({
    __css: styles.control,
    className: "tqc-checkbox__control"
  }, checkboxProps), clonedIcon), children && /*#__PURE__*/React.createElement(tqc.div, _extends({
    className: "tqc-checkbox__label"
  }, labelProps, {
    __css: _objectSpread({
      marginStart: spacing
    }, styles.label)
  }), children));
});
if (__DEV__) {
  Checkbox.displayName = 'Checkbox';
}